import {Component, ReactNode} from 'react';
import Link from 'next/link';
import styles from './portal-top-bar.component.module.scss';

export interface BreadcrumbItem {
    label: string;
    href?: string;
}

interface Props {
    breadcrumbs: BreadcrumbItem[];
    rightSlot?: ReactNode;
}

/**
 * Persistent top bar — slim breadcrumbs on the left, Docs/Help links
 * + account-menu slot on the right. Mounted by PortalLayout above the
 * main content slot for every signed-in portal page.
 */
export default class PortalTopBar extends Component<Props> {
    render() {
        const {breadcrumbs, rightSlot} = this.props;
        return (
            <div className={styles.bar}>
                <nav className={styles.crumbs} aria-label="Breadcrumb">
                    {breadcrumbs.map((c, i) => {
                        const isLast = i === breadcrumbs.length - 1;
                        return (
                            <span key={`${c.label}-${i}`} data-testid="topbar-crumb">
                                {c.href && !isLast
                                    ? <Link href={c.href} className={styles.crumbLink}>{c.label}</Link>
                                    : <span className={isLast ? styles.crumbCurrent : undefined}>{c.label}</span>}
                                {!isLast && <span className={styles.crumbSep}>/</span>}
                            </span>
                        );
                    })}
                </nav>
                <div className={styles.actions}>
                    <a className={styles.actionLink} href="/docs" target="_blank" rel="noreferrer">Docs ↗</a>
                    <a className={styles.actionLink} href="mailto:support@xconvert.com">Help</a>
                    {rightSlot}
                </div>
            </div>
        );
    }
}
